import VisibilityIcon from "@mui/icons-material/Visibility";
import { IconButton } from "@mui/material";
import { isDocumentoDigital } from "../constants/documentos-bs";

export function PreviewAreaBs({
  activeTab,
  files,
  filePreviews,
  onToggleView,
  onDelete,
  onOpenUpload,
  onSubmit,
  showHistorial,
  onHistorial,
  faltaPrefactura,
}) {
  const previews = filePreviews[activeTab] ?? [];
  const esDigital = isDocumentoDigital(activeTab);

  if (faltaPrefactura) {
    return (
      <div className="w-full bg-white p-6 rounded-lg shadow-lg">
        <div className="flex flex-col items-center justify-center text-center py-16 px-6 bg-amber-50 border border-amber-200 rounded-lg">
          <span className="text-4xl mb-3">⚠️</span>
          <p className="text-lg font-semibold text-amber-800">Falta ingresar la prefactura</p>
          <p className="text-sm text-amber-700 mt-2 max-w-md">
            "{activeTab}" se genera automáticamente con los datos de la compra. Ingresa la
            prefactura de esta solicitud para que este documento se genere.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full bg-white p-6 rounded-lg shadow-lg">
      {showHistorial && (
        <div className="flex justify-center items-center w-full">
          <div className="pb-4 pt-5 md:absolute md:right-11">
            <button
              onClick={onHistorial}
              className="bg-blue-600 text-white py-2 px-6 rounded-md shadow-lg hover:bg-blue-700 transition duration-300"
            >
              Historial Observaciones
            </button>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
        {previews.map((previewUrl, index) => {
          const file = files[activeTab]?.[index];
          if (file?.estado === 5) return null;
          return (
            <div
              key={index}
              className="bg-gray-50 p-4 rounded-md shadow-md border border-gray-200 hover:border-blue-500 transition duration-300 flex flex-col"
              style={{ height: "70vh", width: "70vw" }}
            >
              <div className="flex justify-between items-center">
                <span className="text-sm font-medium text-gray-700">
                  {file?.name || "Sin nombre"}
                </span>
                <div className="flex items-center gap-2">
                  <IconButton onClick={onToggleView}>
                    <VisibilityIcon />
                  </IconButton>
                  {!file?.esDigital && (
                    <button
                      type="button"
                      onClick={() => onDelete(activeTab, index)}
                      className="text-red-500 hover:text-red-700"
                    >
                      ❌
                    </button>
                  )}
                </div>
              </div>
              <div className="flex-1 overflow-hidden">
                <object
                  data={previewUrl}
                  type="application/pdf"
                  className="w-full h-full rounded-md"
                  aria-label="Vista previa PDF"
                >
                  <p>Vista previa no disponible</p>
                </object>
              </div>
            </div>
          );
        })}
      </div>

      {!esDigital && (
        <div className="flex justify-center items-center mt-6 w-full">
          <button
            onClick={onOpenUpload}
            className="cursor-pointer relative after:content-['subir_archivos'] after:text-white after:absolute after:text-nowrap after:scale-0 hover:after:scale-100 after:duration-700 w-11 h-11 rounded-full bg-[#2563eb] flex items-center justify-center duration-300 hover:rounded-md hover:w-36 hover:h-10 group/button overflow-hidden active:scale-90"
          >
            <svg
              className="w-7 h-7 fill-white delay-50 duration-200 group-hover/button:-translate-y-12 sm:w-20 sm:h-20"
              stroke="#000000"
              strokeWidth="2"
              viewBox="-3.84 -3.84 31.68 31.68"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_iconCarrier">
                <path
                  opacity="0.1"
                  d="M17.8284 6.82843C18.4065 7.40649 18.6955 7.69552 18.8478 8.06306C19 8.4306 19 8.83935 19 9.65685L19 17C19 18.8856 19 19.8284 18.4142 20.4142C17.8284 21 16.8856 21 15 21H9C7.11438 21 6.17157 21 5.58579 20.4142C5 19.8284 5 18.8856 5 17L5 7C5 5.11438 5 4.17157 5.58579 3.58579C6.17157 3 7.11438 3 9 3H12.3431C13.1606 3 13.5694 3 13.9369 3.15224C14.3045 3.30448 14.5935 3.59351 15.1716 4.17157L17.8284 6.82843Z"
                  fill="#f7f7f7"
                />
                <path
                  d="M17.8284 6.82843C18.4065 7.40649 18.6955 7.69552 18.8478 8.06306C19 8.4306 19 8.83935 19 9.65685L19 17C19 18.8856 19 19.8284 18.4142 20.4142C17.8284 21 16.8856 21 15 21H9C7.11438 21 6.17157 21 5.58579 20.4142C5 19.8284 5 18.8856 5 17L5 7C5 5.11438 5 4.17157 5.58579 3.58579C6.17157 3 7.11438 3 9 3H12.3431C13.1606 3 13.5694 3 13.9369 3.15224C14.3045 3.30448 14.5935 3.59351 15.1716 4.17157L17.8284 6.82843Z"
                  stroke="#000000"
                  strokeWidth="2"
                  strokeLinejoin="round"
                />
                <path d="M12 11L12 16" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M14.5 13.5L9.5 13.5" stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </g>
            </svg>
          </button>

          <div className="ml-4 md:absolute md:right-11">
            <button
              onClick={onSubmit}
              className="bg-blue-600 text-white py-2 px-6 rounded-md shadow-lg hover:bg-blue-700 transition duration-300"
            >
              Enviar archivos
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
